import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap";

// Connects to data-controller="order-accordeon"
export default class extends Controller {
  static targets = ["preview", "insideContent", "contentWrapper"];

  connect() {}

  onToggleClick = (e) => {
    if (e.target.localName == "a") {
      return;
    }

    e.preventDefault();
    if (this.element.classList.contains("is-opened")) {
      this.element.classList.remove("is-opened");
    } else {
      this.element.classList.add("is-opened");
    }
    this.recalculateHeight();
  };

  recalculateHeight = () => {
    if (this.element.classList.contains("is-opened")) {
      gsap.to(this.contentWrapperTarget, {
        duration: 0.3,
        height: this.insideContentTarget.offsetHeight < 200 ? 200 : this.insideContentTarget.offsetHeight
      });
    } else {
      gsap.to(this.contentWrapperTarget, {
        delay: 0.2,
        duration: 0.3,
        height: this.previewTarget.offsetHeight
      });
    }
  };

  disconnect() {}
}
